document.querySelectorAll('.js-testimonial-slider').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('.js-testimonial-slide'));
  const dots = Array.from(slider.querySelectorAll('.js-testimonial-dot'));

  if (!slides.length) return;

  let activeIndex = 0;
  let isAnimating = false;
  let queuedIndex = null;
  let pointerId = null;
  let dragStartX = 0;
  let dragStartY = 0;
  let isDragging = false;
  const transitionDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 760;
  const dragThreshold = 50;

  const updateDots = (index) => {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      dot.tabIndex = isActive ? 0 : -1;
    });
  };

  const showSlide = (index, moveFocus = false) => {
    const targetIndex = (index + slides.length) % slides.length;
    if (targetIndex === activeIndex) return;

    if (isAnimating) {
      queuedIndex = targetIndex;
      return;
    }

    const currentSlide = slides[activeIndex];
    const nextSlide = slides[targetIndex];
    isAnimating = true;

    currentSlide.classList.remove('is-active');
    currentSlide.classList.add('is-leaving');
    currentSlide.setAttribute('aria-hidden', 'true');

    nextSlide.classList.add('is-entering');
    nextSlide.setAttribute('aria-hidden', 'false');
    nextSlide.getBoundingClientRect();
    nextSlide.classList.add('is-active');
    nextSlide.classList.remove('is-entering');

    activeIndex = targetIndex;
    updateDots(activeIndex);
    if (moveFocus && dots[activeIndex]) dots[activeIndex].focus();

    window.setTimeout(() => {
      currentSlide.classList.remove('is-leaving');
      isAnimating = false;

      if (queuedIndex !== null && queuedIndex !== activeIndex) {
        const nextIndex = queuedIndex;
        queuedIndex = null;
        showSlide(nextIndex);
      } else {
        queuedIndex = null;
      }
    }, transitionDuration);
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => showSlide(index));
  });

  slider.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    if (event.target.closest('a, button, input, select, textarea')) return;

    pointerId = event.pointerId;
    dragStartX = event.clientX;
    dragStartY = event.clientY;
    isDragging = false;
    slider.setPointerCapture?.(pointerId);
  });

  slider.addEventListener('pointermove', (event) => {
    if (event.pointerId !== pointerId) return;

    const deltaX = event.clientX - dragStartX;
    const deltaY = event.clientY - dragStartY;

    if (!isDragging && Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
      isDragging = true;
      slider.classList.add('is-dragging');
    }

    if (isDragging) event.preventDefault();
  });

  const finishDrag = (event, navigate = true) => {
    if (event.pointerId !== pointerId) return;

    const deltaX = event.clientX - dragStartX;
    const shouldNavigate = navigate && isDragging && Math.abs(deltaX) >= dragThreshold;

    if (slider.hasPointerCapture?.(pointerId)) slider.releasePointerCapture(pointerId);
    slider.classList.remove('is-dragging');
    pointerId = null;
    isDragging = false;

    if (shouldNavigate) showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
  };

  slider.addEventListener('pointerup', (event) => finishDrag(event));
  slider.addEventListener('pointercancel', (event) => finishDrag(event, false));

  slider.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    event.preventDefault();
    showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
  });

  updateDots(activeIndex);
});
